import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../../utils/decorators";
import BaseModalView from "./base-modal-view"


@Options({
    template: require("../templates/select-parking-view.njk"),
})
export default class SelectParkingView extends Marionette.View<Backbone.Model>{
    onAttach() {
        const select = $('[data-js-select2]');
        if (select.length) {
            select.each(function(index:number, el:any) {
                let placeholder = (<any>$(el)).data('selectPlaceholder') || "";
                (<any>$(el)).select2({
                    dropdownAutoWidth: true,
                    minimumResultsForSearch: Infinity, // removes search bar in results
                    placeholder: placeholder,
                    allowClear: true,
                });
            });
        }
        $('body').addClass("parking_select_arrow_move");
    }

    onDetach() {
        $('body').removeClass("parking_select_arrow_move");

    }
}



// WEBPACK FOOTER //
// ./@modules/modals/views/select-parking-view.ts